// @ts-nocheck
import 'construct-style-sheets-polyfill';
import { OmniElementNext } from 'omni-ui/omni-element-next.js';
import { html, OmniStyleElement } from 'omni-ui';
import { OmniAppContainer, OmniAppContainerMixin } from 'omni-app-container';

OmniStyleElement.register();
OmniAppContainer.register();

/**
 * Class for TidbitsDev
 * @extends OmniElementNext
 * @mixes OmniAppContainerMixin
 */
export class TidbitsDev extends OmniAppContainerMixin(OmniElementNext) {
  static routes = () => [
    {
      path: '/',
      action: async () => {
        await import('./tidbits-container.js');
      },
      component: 'tidbits-container',
    },
  ];

  render() {
    return html`<slot></slot>`;
  }
}

OmniElementNext.register('tidbits-dev', TidbitsDev);
